import Home from "@/views/Home/Index/Index.vue";
import PCLanding from "@/views/Home/Index/PCLanding.vue";
import Mobile from "@/views/Home/Index/Mobile.vue";
import OldApp from "@/views/Home/Index/OldApp.vue";
import { ROUTER_NAME } from "@/utils/config";

const routes = [
  {
    path: ROUTER_NAME.HOME,
    name: "home",
    component: Home
  },
  {
    path: ROUTER_NAME.PCLANDING,
    name: "pcLanding",
    component: PCLanding
  },
  {
    path: ROUTER_NAME.MOBILE,
    name: "mobile",
    component: Mobile
  },
  {
    path: ROUTER_NAME.OLDAPP,
    name: "oldApp",
    component: OldApp
  },
  {
    path: "/:catchAll(.*)",
    name: "all",
    redirect: "/",
    component: Home
  }
];

export default routes;
